// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-alert{border-radius:0!important}.v-alert.warning,.v-alert__icon{color:#502121!important}.v-alert.warning a{color:#502121;font-weight:700}.v-alert.warning a:hover{color:#502121}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
